<template>
  <div>
    <form
      ref="form"
      @submit.prevent="checkForm"
    >
      <!-- 모달 컨텐츠 -->
      <div class="modal__contents">
        <div class="modal__middlebox">
          <div class="modal__row">
            <h2 class="subtitle subtitle--modal">
              프로젝트 이름을 알려주세요
            </h2>
          </div>  
          <div class="modal__row">
            <div class="formfield__row">
              <div class="formfield__inputitem">
                <div class="formfield__inputbox">
                  <input
                    v-model.trim="req.title"
                    type="text"
                    class="formfield__input"
                    autocomplete="off"
                    required="required"
                  >
                </div>
              </div>        
            </div>
          </div>
          <div class="modal__row">
            <span class="guidetext--modal">
              정확하지 않아도 좋습니다<br>프로젝트 성격을 나타낼수 있는 이름을 작성 해주세요
            </span>
          </div>           
        </div>
      </div>
      <!-- 모달 푸터(bottom) -->
      <div class="modal__footer">
        <ul class="modal__buttons">     
          <li class="modal__buttonitem">
            <button
              type="submit"
              class="button button--large"
              :disabled="!req.title"
            >
              다음
            </button>
          </li>
        </ul>
      </div>
    </form>
  </div>
</template>
<script>

export default{
  name:'Title',
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  emits: ['next-step'],
  data(){
    return {
      req: this.request
    }
  },
  methods:{
    checkForm() {
      console.log(this.req)
      this.$emit('next-step')
    }
  }
}
</script>
<style lang="scss" scoped>
.modal{
  $self:&;  
  &__buttons{
    width:160px;
    margin:0 auto;
    &:after{
      content:'';
      clear:both;
      display:inline;
    }
  }
  &__buttonitem{
    float:left;
    width:160px;
    height:50px;
    &:not(:first-child){
      margin-left:10px;
    }
  }
}
.formfield{
  $self:&;
  &__row{
    margin:0 auto;
    width:500px;
  }
  &__inputitem{
    width:100%;
    height:50px;
    text-align:left;
    position: relative;    
    &:not(:first-child){
      margin-left:10px;
    }
  }
}
</style>